import { useState } from 'react'
import { useAuth } from '@/contexts/AuthProvider'
import { useMobileNotifications } from '@/hooks/useMobileNotifications'
import NotificationDrawer from './NotificationDrawer'
import { Bell, WifiOff } from 'lucide-react'
import { useOnlineStatus } from '@/hooks/useOnlineStatus'
import { cn } from '@/lib/utils'

export default function MobileHeader() {
  const { userProfile, company } = useAuth()
  const isOnline = useOnlineStatus()
  const { notifications, unreadCount, loading, markAsRead, markAllAsRead } = useMobileNotifications(userProfile?.id)
  const [drawerOpen, setDrawerOpen] = useState(false)

  return (
    <>
      <header className="bg-white border-b border-gray-200 px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          {company?.logo_url ? (
            <img src={company.logo_url} alt="" className="h-8 w-8 rounded-lg object-cover" />
          ) : (
            <div className="h-8 w-8 rounded-lg bg-emerald-600 flex items-center justify-center text-white text-xs font-bold">
              {company?.name?.[0] || 'T'}
            </div>
          )}
          <span className="font-semibold text-gray-900 text-sm">{company?.name || 'Training Profile'}</span>
        </div>

        <div className="flex items-center gap-2">
          {!isOnline && <WifiOff className="h-4 w-4 text-amber-500" />}
          <button
            onClick={() => setDrawerOpen(true)}
            className="relative p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <Bell className="h-5 w-5 text-gray-600" />
            {unreadCount > 0 && (
              <span className={cn(
                'absolute top-1 right-1 flex items-center justify-center rounded-full bg-red-500 text-white text-[9px] font-bold leading-none',
                unreadCount > 9 ? 'h-4 min-w-4 px-0.5' : 'h-3.5 w-3.5'
              )}>
                {unreadCount > 99 ? '99+' : unreadCount}
              </span>
            )}
          </button>
        </div>
      </header>

      <NotificationDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        notifications={notifications}
        unreadCount={unreadCount}
        onMarkAsRead={markAsRead}
        onMarkAllAsRead={markAllAsRead}
        loading={loading}
      />
    </>
  )
}
